import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { IconButton, Popover, Typography } from '@material-ui/core';
import { AddCircle, Description, MoreVert, RemoveCircle } from '@material-ui/icons';
import { useTraceBoardContext } from './TraceBoardContext';
const StyledDiv = styled.div `
  display: flex;
  white-space: nowrap;
  flex-wrap: nowrap;
  background: #fff;
  padding: 0 12px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 1;
  .expand-collapse {
    padding: 12px 10px 12px 9px;
    .icon-button {
      .collapse {
        color: #fec400;
      }
      .expand {
        color: #29cc97;
      }
    }
  }
  .column-header {
    display: flex;
    flex: 1;
    min-width: 320px;
    align-items: center;
    padding: 12px 16px;
    border-right: 1px solid #dfe0eb;
    &:last-child {
      border-right: none;
    }
    .buttons {
      display: flex;
      flex: 1;
      justify-content: flex-end;
    }
    .title {
      margin-left: 6px;
    }
    .column-header-link {
      color: #000;
    }
  }
`;
const TraceBoardHeader = () => {
    const { columns, collapse } = useTraceBoardContext();
    const [moreMenu, setMoreMenu] = useState();
    const [popoverProps, setPopoverProps] = useState({});
    const menuColumn = moreMenu
        ? columns.find(column => column.id === moreMenu.columnId)
        : undefined;
    return (React.createElement(StyledDiv, { className: 'board-header' },
        React.createElement("div", { className: 'expand-collapse' },
            React.createElement(IconButton, { size: 'small', className: 'icon-button', onClick: () => collapse.toggle() }, collapse.partial ? (React.createElement(RemoveCircle, { className: 'collapse' })) : (React.createElement(AddCircle, { className: 'expand' })))),
        columns.map(column => (React.createElement("div", { key: column.id, className: 'column-header' },
            React.createElement(Description, null),
            React.createElement(Typography, { variant: 'overline', className: 'title' }, column.headerLink ? (React.createElement(Link, { className: 'column-header-link', to: column.headerLink }, column.name)) : (column.name)),
            React.createElement("div", { className: 'buttons' }, column.renderColumnMenu && (React.createElement(IconButton, { size: 'small', onClick: event => {
                    setMoreMenu({
                        columnId: column.id,
                        anchorElement: event.currentTarget
                    });
                } },
                React.createElement(MoreVert, null))))))),
        moreMenu && (menuColumn === null || menuColumn === void 0 ? void 0 : menuColumn.renderColumnMenu) && (React.createElement(Popover, Object.assign({ open: true, anchorEl: moreMenu.anchorElement, onClose: () => setMoreMenu(undefined) }, popoverProps), menuColumn.renderColumnMenu({ column: menuColumn }, () => setMoreMenu(undefined), () => {
            // handle anchoring if column menu is dynamic / async loading
            setPopoverProps({
                anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
                transformOrigin: { vertical: 'top', horizontal: 'right' }
            });
        })))));
};
export default TraceBoardHeader;
//# sourceMappingURL=TraceBoardHeader.js.map